import { addToCart } from '@nova/utils'

document.addEventListener('DOMContentLoaded', () => {
  const $forms = Array.from(document.querySelectorAll('.js-product-form') || [])
  const $sizeGuideBtns =
    document.querySelectorAll('.js-size-guide-button') || []
  const $sizeGuideDrawer = document.querySelector('.js-size-guide-drawer') || []

  if ($forms.length) {
    for (const $form of $forms) {
      const $submitButton = $form.querySelector('[type="submit"]')
      const $quantityInput = document.querySelector(
        `nova-quantity-input[data-form-id=${$form.getAttribute('id')}]`,
      )
      $form.addEventListener('submit', (event) => {
        event.preventDefault()

        $submitButton.setAttribute('disabled', true)
        $submitButton.classList.add('loading')

        const formData = new FormData($form)
        const id = formData.get('id')
        const quantity = $quantityInput.value

        addToCart({ id, quantity }).then(() => {
          $submitButton.removeAttribute('disabled')
          $submitButton.classList.remove('loading')
        })
      })
    }

    document.addEventListener('nova:product:render-form', (event) => {
      const content = event.detail.html
      for (const $form of $forms) {
        if (!content) return
        $form.innerHTML = content.innerHTML
      }
    })
  }

  const accordionProductDetails = document.querySelector('.js-accordion-product-details')

  if (accordionProductDetails) {
    document.addEventListener('nova:product:render-accordion-product-details', (event) => {
      const content = event.detail.html
      accordionProductDetails.innerHTML = content.innerHTML
    })
  }

  if ($sizeGuideDrawer) {
    for (const $button of $sizeGuideBtns) {
      $button.addEventListener('click', () => {
        if ($sizeGuideDrawer.hasAttribute('open')) {
          $sizeGuideDrawer.hide()
        } else {
          $sizeGuideDrawer.show()
        }
      })
    }
  }
})
